import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import "../styles/Login.css"; // Reuse login styles

function JoinGame() {
  const [gameId, setGameId] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleJoinGame = (e) => {
    e.preventDefault();

    if (!gameId.trim()) {
      setError("Please enter a game ID");
      return;
    }

    // Redirect to the game page with the provided ID
    navigate(`/game/${gameId}`);
  };

  const handleBackToHome = () => {
    if (auth.currentUser) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-shape login-shape-primary"></div>
        <div className="login-shape login-shape-secondary"></div>
      </div>

      <div className="login-form">
        <h3>Join Existing Game</h3>

        <form onSubmit={handleJoinGame}>
          <label htmlFor="gameId">Game ID</label>
          <input
            type="text"
            value={gameId}
            onChange={(e) => setGameId(e.target.value)}
            placeholder="Enter Game ID"
            id="gameId"
            required
          />

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="login-button">
            Join Game
          </button>
        </form>

        <button
          type="button"
          className="signup-button"
          onClick={handleBackToHome}
        >
          Back
        </button>
      </div>
    </div>
  );
}

export default JoinGame;
